import NamespaceApi from "../../services/api/Namespace";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import qs from "qs";
import { getPath } from "../../utils";
import { amber } from "@material-ui/core/colors";

function handleError(err) {
  console.log("error in change logs actions:", err);
}

export const getNamespaces =
  (payload = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...payload,
      };
      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await NamespaceApi.getNamespaces(queryParams);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const upsertNamespace = (data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await NamespaceApi.upsertNamespace(data);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const syncNamespace = (data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await NamespaceApi.syncNamespace(data);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: getPath(
            response,
            "message",
            SuccessMessages.UPDATION_SUCCESS
          ),
        })
      );
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getNamespaceVersions = (namespace) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await NamespaceApi.getNamespaceVersions(namespace);
    dispatch(setLoader(false));
    if (response) {
      response.version_info = response.version_info?.map((element) => {
        return {
          ...element,
          label: `Version: ${element.version} Time: ${element.timestamp}`,
        };
      });
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
